import { Spot } from '../store/playerSlice';

export const isSpot = (spot: unknown): spot is Spot => {
  return typeof spot === 'object' && spot !== null && 'id' in spot && spot.id === 'spot';
};
